import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const Care: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      d="M34.263 13.737a2.053 2.053 0 0 0-2.052 2.052v6.158h-1.027V9.632a2.053 2.053 0 1 0-4.105 0v12.315h-1.026V6.553a2.053 2.053 0 0 0-4.106 0v15.394h-1.026V9.632a2.053 2.053 0 1 0-4.105 0v18.473l-1.026.358v-7.542a2.053 2.053 0 1 0-4.106 0v10.263C11.684 37.986 17.198 43.5 24 43.5c6.802 0 12.316-5.514 12.316-12.316V15.79a2.053 2.053 0 0 0-2.053-2.052z"
      style={{
        fill: '#002677',
      }}
    />
    <path
      d="M30.964 25.388a4.256 4.256 0 0 0-6.018 0l-.946.945-.946-.945a4.256 4.256 0 0 0-6.018 6.018l6.962 6.962.002-.001.002.001 6.962-6.962a4.256 4.256 0 0 0 0-6.018z"
      style={{
        fill: '#ff612b',
      }}
    />
  </Box>
)
export default Care
